import { render } from "./Profile.vue?vue&type=template&id=4dc0a370&scoped=true"
import script from "./Profile.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Profile.vue?vue&type=script&charset=utf-8&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=4dc0a370&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc0a370"]])

export default __exports__